"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellablePromise = void 0;
class Cancelled extends Error {
    constructor(reason = '') {
        super(reason);
        Object.setPrototypeOf(this, Cancelled.prototype);
    }
}
class CancellablePromise extends Promise {
    constructor(promise) {
        super((resolve, reject) => {
            promise.then((v) => {
                if (this._isCancelled) {
                    reject(new Cancelled(this._isCancelled));
                    return;
                }
                resolve(v);
            }, (e) => {
                if (this._isCancelled) {
                    reject(new Cancelled(this._isCancelled));
                    return;
                }
                reject(e);
            });
        });
        this._isCancelled = false;
    }
    cancel(reason) {
        this._isCancelled = reason !== null && reason !== void 0 ? reason : '';
        return this;
    }
    get isCancelled() {
        return this._isCancelled !== false;
    }
}
exports.CancellablePromise = CancellablePromise;
//# sourceMappingURL=cancellablePromise.js.map